import React from 'react'
import 'regenerator-runtime/runtime'
import MyRooms from '../routes/MyRooms'

const Routes = () => {
  return <MyRooms />
}

export default Routes
